<script>

import Service from '@/services/planning';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericCustomAutocompleteV2 from '@/components/generic/GenericCustomAutocompleteV2.vue';

import CommonConstants from '@/common/Constants';
import Utils from '@/common/Utils';
import { FilterMatchMode } from 'primevue/api';

export default{
    props: ['showCreate', 'showLink', 'idMovementInstructionHeader', 'startDate', 'endDate', 'id', 'hideFilters', 'idRegistryProduct'],
    emits: ['linkTheoreticalLot'],
    components: {
        ResponsiveButton,
        GenericCustomMasterDataAutocompleteV2,
        GenericCustomAutocompleteV2

    },
    created(){
    },
    mounted(){

        if(this.showCreate && !this.hideFilters){
            this.additionalFilters.startDate = Utils.formatDatePlusDays(new Date(), -30);
            this.additionalFilters.endDate = Utils.formatDatePlusDays(new Date(), 30);
        }
        if(this.startDate){
            this.additionalFilters.startDate = Utils.formatDatePlusDays(this.startDate, -2);
            this.additionalFilters.endDate = Utils.formatDatePlusDays(this.startDate, 2);
        }
        if(this.idRegistryProduct){
            this.filters.plannedIdRegistryProduct.value = this.idRegistryProduct;
        }
        this.loadTheoreticalLots();
    },
    data(){
        return{
            data: [],
            loading: false,
            filters: {
                plannedIdRegistryPlant: { value: null, matchMode: FilterMatchMode.EQUALS },
                plannedIdRegistryProduct: { value: null, matchMode: FilterMatchMode.EQUALS },
                plannedLaycanStartDate: { value: null, matchMode: FilterMatchMode.DATE_AFTER, type: 'date' },
            },
            additionalFilters: {
                startDate: null,
                endDate: null
            }
        }
    },
    watch: {
        'additionalFilters.startDate'(){
            if(this.additionalFilters.startDate){
                this.loadTheoreticalLots();
            }
        },
        'additionalFilters.endDate'(){
            if(this.additionalFilters.endDate){
                this.loadTheoreticalLots();
            }
        }
    }, 
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        }
    },
    methods: {
        loadTheoreticalLots(){
            this.data = []
            this.loading = true;
            if(this.id){
                Service.getTheoreticalLot(this.id, response => {
                    this.loading = false;
                    if(response.success){
                        this.data.push(response.data);
                        for(let i=0; i<this.data.length; i++){
                            this.data[i].plannedLaycanStartDate = this.data[i].plannedLaycanStartDate ? new Date(Utils.dateToCurrentTimeZone(this.data[i].plannedLaycanStartDate)) : null;
                            this.data[i].plannedLaycanEndDate = this.data[i].plannedLaycanEndDate ? new Date(Utils.dateToCurrentTimeZone(this.data[i].plannedLaycanEndDate)) : null;
                        }
                    }    
                });
            }else{
                let body = {
                    onlyOpened: true,
                    onlyConfirmed: true
                }
                body.startDate = this.additionalFilters.startDate;
                body.endDate = this.additionalFilters.endDate;
                Service.getTheoreticalLots(body, response => {
                    this.loading = false;
                    if(response.success){
                        this.data = response.data;
                        for(let i=0; i<this.data.length; i++){
                            this.data[i].plannedLaycanStartDate = this.data[i].plannedLaycanStartDate ? new Date(Utils.dateToCurrentTimeZone(this.data[i].plannedLaycanStartDate)) : null;
                            this.data[i].plannedLaycanEndDate = this.data[i].plannedLaycanEndDate ? new Date(Utils.dateToCurrentTimeZone(this.data[i].plannedLaycanEndDate)) : null;
                        }
                    }    
                });
            }
        },
        createMovementInstruction(data){
            this.$confirm.require({
                message: this.$t('messages.movementInstructionCreateFromTheoreticalLot'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    if(data.idRegistryOperationType){
                        Service.createMovementInstruction(data, response => {
                            // this.$store.dispatch("generic/setLoading", false);
                            if(response.success){

                                this.$store.dispatch("movementInstruction/setTheoreticalLot", {
                                    idMovementInstructionHeder: response.data,
                                    data: data
                                });

                                let uri = `/movement-instruction/${response.data}?fromTheoreticalLot=true`;
                                this.$router.push(uri);
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        })
                    }else{
                        this.$toast.add({detail: this.$t('messages.operationTypeRequired'), life:3000, severity:'error'});
                    }
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
            // this.$store.dispatch("generic/setLoading", true);
            
        },

        linkMovementInstruction(data){
            this.$confirm.require({
                message: this.$t('messages.movementInstructionLinkTheoreticalLot'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$emit('linkTheoreticalLot', data.id);
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        }
    }
}

</script>

<template>
    <main>
        <div class="grid">
            <div class="col-12" v-if="!id">
                <div class="grid">
                    <div class="col-3">
                        <label>{{ $t('vesselSummary.startDate') }}</label>
                        <Calendar 
                            class="w-full" 
                            v-model="additionalFilters.startDate" 
                            dateFormat="dd/mm/yy" 
                            placeholder="dd/mm/yyyy" />
                    </div>
                    <div class="col-3">
                        <label>{{ $t('vesselSummary.endDate') }}</label>
                        <Calendar 
                            class="w-full" 
                            v-model="additionalFilters.endDate" 
                            dateFormat="dd/mm/yy" 
                            placeholder="dd/mm/yyyy" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <DataTable 
                    v-model:filters="filters" filterDisplay="row"
                    responsiveLayout="scroll" :scrollable="true" :scrollHeight="'flex'"
                    class="p-datatable-sm my-2" :reorderableColumns="true"
                    :value="data" showGridlines stripedRows :loading="loading"
                    paginator :rows="25">
                    <Column field="plannedIdRegistryPlant" :header="$t('registryPlant.fk')">
                        <template #body="{ data, field }">
                            <GenericCustomMasterDataAutocompleteV2
                                :name="field"
                                v-model="data[field]"
                                :api="'masterdata/registry-plant-combo'" v-if="showCreate"/>
                                <p v-else>{{data.plannedRegistryPlant  }}</p>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <GenericCustomAutocompleteV2
                                :name="'plannedIdRegistryPlant'"
                                v-model="filterModel.value"
                                @change="filterCallback()"
                                :api="'masterdata/registry-plant-combo'"
                                :format="{label: 'label',value: 'value'}" />
                            <!-- <InputText v-model="filterModel.value" type="text"  class="p-column-filter" placeholder="Search by name" /> -->
                        </template>
                    </Column>
                    <Column field="plannedLaycanStartDate" :header="$t('movementInstructions.laycanFrom')">
                        <template #body="{ data, field }">
                            <Calendar 
                                class="w-full" 
                                v-model="data[field]" 
                                dateFormat="dd/mm/yy" 
                                placeholder="dd/mm/yyyy" v-if="showCreate"/>
                                <p v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</p>
                        </template>
                    </Column>
                    <Column field="plannedLaycanEndDate" :header="$t('movementInstructions.laycanTo')" >
                        <template #body="{ data, field }">
                            <Calendar 
                                class="w-full" 
                                v-model="data[field]" 
                                dateFormat="dd/mm/yy" 
                                placeholder="dd/mm/yyyy" v-if="showCreate"/>
                                <p v-else>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</p>
                        </template>
                    </Column>
                    <Column field="plannedIdRegistryProduct" :header="$t('product.fk')">
                        <template #body="{ data, field }">
                            <GenericCustomMasterDataAutocompleteV2
                                :name="field"
                                v-model="data[field]"
                                :api="'masterdata/product-combo'"  v-if="showCreate"/>
                                <p v-else>{{data.plannedRegistryProductCode + ' - ' + data.plannedRegistryProduct  }}</p>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <GenericCustomAutocompleteV2
                                :name="'plannedIdRegistryProduct'"
                                v-model="filterModel.value"
                                @change="filterCallback()"
                                :api="'masterdata/product-combo'"
                                :format="{label: 'label',value: 'value'}"/>
                            <!-- <InputText v-model="filterModel.value" type="text"  class="p-column-filter" placeholder="Search by name" /> -->
                        </template>
                        </Column>
                    <Column field="plannedQuantity" :header="$t('movementInstructions.quantity')">
                        <template #body="{ data, field }">
                            <InputNumber
                                class="w-full" :minFractionDigits="0" :maxFractionDigits="0"
                                v-model="data[field]" v-if="showCreate"/>
                                <p v-else>{{data[field]  }}</p>
                        </template>
                    </Column>
                    <Column field="plannedMinimumQuantity" :header="$t('movementInstructions.minimumQuantity')">
                        <template #body="{ data, field }">
                            <InputNumber
                                class="w-full" :minFractionDigits="0" :maxFractionDigits="0"
                                v-model="data[field]" v-if="showCreate"/>
                                <p v-else>{{data[field]  }}</p>
                        </template>
                    </Column>
                    <Column field="plannedMaximumQuantity" :header="$t('movementInstructions.maximumQuantity')">
                        <template #body="{ data, field }">
                            <InputNumber
                                class="w-full" :minFractionDigits="0" :maxFractionDigits="0"
                                v-model="data[field]" v-if="showCreate"/>
                                <p v-else>{{data[field]  }}</p>
                        </template>
                    </Column>
                    <Column field="idRegistryOperationType" :header="$t('operationType.fk')" v-if="showCreate">
                        <template #body="{ data, field }">
                            <GenericCustomMasterDataAutocompleteV2
                            v-model="data[field]" 
                            name="user-role-operation-type-combo"
                            api="movement-instruction/user-role-operation-type-combo"
                            :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                        </template>
                    </Column>
                    <Column :exportable="false">
                        <template #body="slotProps">
                            <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="p-button-sm m-1" @click="createMovementInstruction(slotProps.data)" v-if="showCreate"/>
                            <ResponsiveButton :label="$t('btn.link')" icon="pi pi-link" class="p-button-sm m-1" @click="linkMovementInstruction(slotProps.data)" v-if="showLink"/>
                        </template>
                    </Column>
                    <template #empty>
                        {{$t('noRecordsFound')}}
                    </template>
                </DataTable>
            </div>
        </div>
    </main>
</template>